export default __webpack_public_path__ + "media/images/logo_imastodon_white-93dbcdb9ef53cbfba1547917bac48f1c.svg";